import { Component } from 'react'
import { connect } from 'react-redux'
import TutorialList from 'components/TutorialList'
import { CATEGORY_ICONS } from 'constants'
import { ProductNameHOC } from 'hocs'
import { fetchTutorialList } from './actions'
import { selectTutorials, selectTutorialsFetching } from './selectors'
import { selectCurrentPhoneId } from '../App/selectors'
import { updateTitle } from '../Breadcrumbs/actions'

class TutorialListContainer extends Component {
  state = { currentCategory: null }

  componentDidMount() {
    this.props.updateTitle('Tutorials')

    if (this.props.deviceId) {
      this.props.fetchTutorials(this.props.deviceId)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId && nextProps.deviceId) {
      this.props.fetchTutorials(nextProps.deviceId)
    }
    if (this.props.deviceId !== nextProps.deviceId && !nextProps.deviceId) {
      // Reset state when device is cleared to close all categories
      this.setState({ currentCategory: null })
    }
  }

  handleClick = (id) => {
    this.setState({
      currentCategory: id === this.state.currentCategory ? null : id
    })
  }

  icon = (category) => CATEGORY_ICONS[category] || 'folder-outline'

  generateProps = () => ({
    ...this.props,
    ...this.state,
    handleClick: this.handleClick,
    icon: this.icon
  })

  render() {
    return <TutorialList {...this.generateProps()} />
  }
}

const mapStateToProps = (state) => ({
  tutorials: selectTutorials(state),
  isFetching: selectTutorialsFetching(state),
  deviceId: selectCurrentPhoneId(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchTutorials: (deviceId) => dispatch(fetchTutorialList.request(deviceId)),
  updateTitle: (title) => dispatch(updateTitle(title))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductNameHOC(TutorialListContainer))
